import { ThreadColor } from './ThreadColor';

export class EmbroideryThreadColor extends ThreadColor {
	constructor(rawData?: object) {
		super(rawData);
	}
}